
import type { App } from "vue";
import PrimeVue from 'primevue/config'
import { definePreset } from '@primevue/themes';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, ToastService } from "primevue";

export function setupPrimeVue(app: App) {

    const AdamPreset = definePreset(Aura, {
        semantic: {
            primary: {
                50: 'var(--primary-color-50)',
                100: 'var(--primary-color-100)',
                200: 'var(--primary-color-200)',
                300: 'var(--primary-color-300)',
                400: 'var(--primary-color-400)',
                500: 'var(--primary-color-500)',
                600: 'var(--primary-color-600)',
                700: 'var(--primary-color-700)',
                800: 'var(--primary-color-800)',
                900: 'var(--primary-color-900)',
                950: 'var(--primary-color-950)'
            },
            formField: {
                // Reduce default PrimeVue control padding for denser layouts
                paddingX: '0.5rem',
                paddingY: '0.35rem',
                borderRadius: '9999px',
                sm: {
                    paddingX: '0.375rem',
                    paddingY: '0.25rem'
                },
                lg: {
                    paddingX: '0.625rem',
                    paddingY: '0.45rem'
                }
            }
        }
    });

    app.use(PrimeVue, {
        theme: {
            preset: AdamPreset,
            options: {
                darkModeSelector: '.is-dark-mode',
                cssLayer: {
                    name: 'primevue',
                    order: 'theme, base, primevue, components, utilities'
                }
            }
        },
        ripple: true,
    });

    app.use(ConfirmationService);
    app.use(ToastService);
}